export default __webpack_public_path__ + "static/media/banner.9fdddd12.png";